import {
  DoorAttemptResult,
  DoorConfig,
  DoorConfigPayload,
  DoorOpening,
  DoorSummary,
} from '../types/responses/DoorAccess';

export const DOOR_TIMEOUT_MS = 10000;

export interface DoorAccessApi {
  getSummary(chargeBoxPk: string | number): Promise<DoorSummary[]>;
  getConfig(
    chargeBoxPk: string | number,
    connectorId: number,
  ): Promise<DoorConfig>;
  saveConfig(
    chargeBoxPk: string | number,
    connectorId: number,
    payload: DoorConfigPayload,
  ): Promise<DoorConfig>;
  testConfig(
    chargeBoxPk: string | number,
    connectorId: number,
    payload: DoorConfigPayload,
  ): Promise<DoorAttemptResult>;
  // payload: config da tela ainda não salva; abre com ela sem gravar (teste antes de salvar)
  open(
    chargeBoxPk: string | number,
    connectorId: number,
    payload?: DoorConfigPayload,
  ): Promise<DoorAttemptResult>;
  getOpenings(
    chargeBoxPk: string | number,
    connectorId: number,
  ): Promise<DoorOpening[]>;
}

export class DoorAccessError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, DoorAccessError.prototype);
  }
}
